import AppBar from '@/components/app-bar/AppBar.vue'
import AppBarSpace from '@/components/app-bar/AppBarSpace.vue'
import contestApi from '@/api/contest'

export default {
    name: 'ProxySignUp',
    components: {
        AppBar,
        AppBarSpace,
    },
    data() {
        return {
            // contestId: this.$route.params.contestId,
            playerInfo: {
                playerName: '',
                playerPhone: '',
                contestId: this.$route.params.contestId,
                idcard: '',
                nation: '',
                qr: '',
                remarks: '',
                sex: '',
            },
            sexList: ['男', '女'],
            nationList: [],
            NATIONLSIT: "汉族、满族、蒙古族、回族、藏族、维吾尔族、苗族、彝族、壮族、布依族、侗族、" +
                "瑶族、白族、土家族、哈尼族、哈萨克族、傣族、黎族、傈僳族、佤族、畲族、高山族、拉祜族、水族、东乡族、纳西族、景颇族、柯尔克孜族、土族、达斡尔族、仫佬族、羌族、布朗族、撒拉族、毛南族、仡佬族" +
                "、锡伯族、阿昌族、普米族、朝鲜族、塔吉克族、怒族、乌孜别克族、俄罗斯族、鄂温克族、德昂族、保安族、裕固族、京族、塔塔尔族、独龙族、鄂伦春族、赫哲族、门巴族、珞巴族、基诺族",
            columns: [],
            SEX: 'SEX',
            NATION: 'NATION',
            currentPickerType: this.SEX,
            showTypePicker: false,
        }
    },
    created() {
        this.nationList = this.NATIONLSIT.split('、')
    },
    methods: {

        showSexPicker() {
            this.currentPickerType = this.SEX
            this.columns = this.sexList
            this.showTypePicker = true
        },
        showNationPicker() {
            this.currentPickerType = this.NATION
            this.columns = this.nationList
            this.showTypePicker = true
        },
        async proxySignUp() {
            if (this.playerInfo.idcard === '' || this.playerInfo.idcard.length === 18) {
                try {
                    await contestApi.proxyPlayerJoin(this.playerInfo)
                    this.$toast.success('代报名成功')
                    this.$router.back()
                } catch (e) {
                    this.$toast.fail(e.message)
                }
            } else {
                this.$toast.fail('请填写正确的身份证号')
            }
        },
        onTypeSelected() {
            this.$refs.typePicker.confirm();
        },
        onConfirm(value) {
            if (this.currentPickerType === this.SEX) {
                this.playerInfo.sex = value;
            } else if (this.currentPickerType === this.NATION) {
                this.playerInfo.nation = value
            }
            this.showTypePicker = false
        },
    }
}
